import React from 'react'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'
import Spacing from '../../../../componenets/UI/Spacing'

export default function LoaderSponsorDetailsPage() {
  const { t } = useTranslation()
  return (
    <div className="app-container px-8 lg:px-0">
      <Helmet>
        <title>{`APFM | ${t('SPONSOR_DIAMOND')} ...`}</title>
      </Helmet>
      <Spacing />
      <div className="mb-4 h-10 w-1/2 animate-pulse bg-muted-300" />
      <div className="mb-8 h-72 w-full animate-pulse bg-muted-300"></div>
      <div className="mb-4 h-10 w-1/2 animate-pulse bg-muted-300" />
      <div className="mb-4 h-4 w-full animate-pulse bg-muted-300" />
      <div className="mb-4 h-4 w-full animate-pulse bg-muted-300" />
      <div className="mb-4 h-4 w-full animate-pulse bg-muted-300" />
      <div className="mb-4 h-4 w-full animate-pulse bg-muted-300" />
      <div className="mb-4 h-4 w-full animate-pulse bg-muted-300" />
      <div className="mb-4 h-4 w-1/2 animate-pulse bg-muted-300" />
      <div className="mb-4 h-4 w-full animate-pulse bg-muted-300" />
      <div className="mb-4 h-4 w-full animate-pulse bg-muted-300" />
      <div className="mb-4 h-4 w-full animate-pulse bg-muted-300" />
      <div className="mb-4 h-4 w-full animate-pulse bg-muted-300" />
      <div className="mb-4 h-4 w-full animate-pulse bg-muted-300" />
      <div className="mb-4 h-4 w-1/3 animate-pulse bg-muted-300" />
      <div className="mb-4 h-4 w-full animate-pulse bg-muted-300" />
    </div>
  )
}
